/**
 * Plugin to automatically "ajaxify" the cart
 */

(function ($) {
  var methods = {
    settings: {
      shopCurrency: window.shop.shopCurrency,
      moneyFormat: window.shop.moneyFormat
    },

    init: function() {
      this.find('.item-quantity input').on('change', $.proxy(methods.updateLine, this));
      this.find('#cart-note').on('change', $.proxy(methods.updateCartNote, this));
    },

    /**
     * @param event
     */
    updateLine: function(event) {
      var elem = $(event.currentTarget),
          moneyFormat = methods.settings['moneyFormat'],
          shopCurrency = methods.settings['shopCurrency'],
          variantId = parseInt(elem.attr('data-variant-id')),
          newCurrency = $('[name=currencies]').val() || shopCurrency,
          newQuantity = elem.val();

      if (parseInt(newQuantity) === 0) {
        // If we have no products, we don't want to trigger an Ajax call otherwise it would remove it from the cart.
        // Therefore we set it back to 1 and return
        elem.val('1');
        return;
      }

      Shopify.changeItem(variantId, newQuantity, function(result) {
        // We need to update the price on the line AND on the total result
        var line = $('.cart-items tr[data-variant-id=' + variantId + ']'),
            total = $('.cart-total .money');

        // Extract the line in the response
        for (var i = 0 ; i != result['items'].length ; ++i) {
          var currentLine = result['items'][i];

          if (currentLine['variant_id'] === variantId) {
            line.find('.item-line-price .money')
              .html(Shopify.formatMoney(currentLine['line_price'], moneyFormat))
              .attr('data-currency', shopCurrency)
              .removeAttr('data-currency-' + newCurrency.toLowerCase());

            break;
          }
        }

        // We need to update the currency in order to trigger a conversion
        total.html(Shopify.formatMoney(result['total_price'], moneyFormat))
          .attr('data-currency', shopCurrency)
          .removeAttr('data-currency-' + newCurrency.toLowerCase());

        Currency.convertAll(shopCurrency, $('[name=currencies]').val());
      });
    },

    /**
     * @param event
     */
    updateCartNote: function(event) {
      var elem = $(event.currentTarget);
      Shopify.updateCartNote(elem.val(), function(cart) {});
    }
  };

  $.fn.cartAjaxify = function(options) {
    return methods.init.call(this, options);
  };
}(jQuery));
/**
 * Plugin to automatically "featurify" an image
 */

(function ($) {
  var methods = {
    /**
     * @type {Object}
     */
    settings: {
      enableZoom: false, // Allow to enable zoom whenever we hover on an image
      listSelector: '.thumbnail-list', // List that holds the link to thumbnails
      magnify: 1,
      triggerEvent: "mouseenter" // Event that trigger the change
    },

    init: function() {
      // Enable the zoom on hover (by using the large image)
      if (methods.settings.enableZoom) {
        this.find('.image-featured').each(function (index, item) {
          var element = $(item);

          if (element.attr('data-fancybox-type') === 'image') {
            element.zoom({
              url: element.attr('href'),
              magnify: methods.settings.magnify
            });
          }
        });
      }

      // We attach a listener for each image in the thumbnail list to change the featured image
      $(methods.settings.listSelector).find('a').on(methods.settings.triggerEvent, $.proxy(methods.updateFeatured, this));
    },

    /**
     * @param event
     */
    updateFeatured: function(event) {
      var target = $(event.currentTarget),
          active = this.find('li.active'),
          imageId = target.attr('data-id');

      // If the settings is to change picture on click, we do not want to trigger the lightbox, so we need to
      // stop propagation, UNLESS the image the user is clicking is the same
      if (methods.settings.triggerEvent === 'click' && target.attr('data-id') !== active.attr('data-image-id')) {
        event.stopPropagation();
        event.preventDefault();
      }

      // We need to switch the image
      this.find('li').removeClass('active')
        .filter('[data-image-id=' + imageId + ']').addClass('active');
    }
  };

  var width = $(window).width();
  if (width > 768) {
    $.fn.featurify = function(options) {
      return methods.init.call(this, options);
    };
  }
  
 
}(jQuery));
/**
 * Plugin to automatically "ajaxify" the product
 */

(function ($) {
  var methods = {
    /**
     * @type {Object}
     */
    settings: {
      addToCartLabel: "Add To Shopping Bag",
      addingToCartLabel: "Adding To Shopping Bag...",
      addedToCartLabel: "Product was added!",

      preOrderAddToCartLabel: "Pre-Order",
      preOrderAddingToCartLabel: "Pre-Ordering...",
      preOrderAddedToCartLabel: "Product was pre-ordered!"
    },

    init: function() {
      // Replace the labels if we are in the "pre-order" template
      if (window.shop.template === 'product.pre-order') {
        methods.settings = {
          addToCartLabel: "Pre-Order",
          addingToCartLabel: "Pre-Ordering...",
          addedToCartLabel: "Product was pre-ordered!"
        };
      }

      this.on('click', $.proxy(methods.addProduct, this));

      Shopify.onError = $.proxy(methods.error, this);
      Shopify.onItemAdded = $.proxy(methods.added, this);
      Shopify.onCartUpdate = $.proxy(methods.cartUpdated, this);
    },

    /**
     * @param event
     */
    addProduct: function(event) {
      // First step, we change the content to the "addingToCartLabel"
      const val = $('.form-control>select').val()
      const quolity = $(`.form-control>select [value='${val}']`).data().inventory_quantity
      if(quolity > 0){
        this.text(methods.settings['addingToCartLabel']);
      }else{
        this.text(methods.settings['preOrderAddingToCartLabel'])
      }
      this.attr('disabled', 'disabled');
      this.addClass('loading');

      Shopify.addItemFromForm('add-to-cart-form');

      return false;
    },

    /**
     * @param response
     */
    added: function(response) {
      const val = $('.form-control>select').val();
      const quolity = $(`.form-control>select [value='${val}']`).data().inventory_quantity;

      if(quolity > 0){
        this.text(methods.settings['addedToCartLabel']);
      }else{
        this.text(methods.settings['preOrderAddedToCartLabel']);
      }

      this.removeClass('loading').addClass('success');

      $('.added-to-cart-links').show();

      // We also need to update the cart info
      Shopify.getCart();

      setTimeout($.proxy(methods.revertDefaults, this), 2500);
    },

    /**
     * @param response
     */
    error: function(response) {
      this.text(response.responseJSON.description);
      this.removeClass('loading').addClass('error');

      setTimeout($.proxy(methods.revertDefaults, this), 2500);
    },

    /**
     *
     */
    revertDefaults: function() {
      const val = $('.form-control>select').val();
      const quolity = $(`.form-control>select [value='${val}']`).data().inventory_quantity;

      if(quolity > 0){
        this.text(methods.settings['addToCartLabel']);
      }else{
        this.text(methods.settings['preOrderAddToCartLabel']);
      }
      this.removeClass('error loading success');
      this.removeAttr('disabled');
    },

    /**
     * @param response
     */
    cartUpdated: function(response) {
      $('.cart-item-count').text(response['item_count']);
    }
  };

  $.fn.productAjaxify = function(options) {
    return methods.init.call(this, options);
  };
}(jQuery));


/**
 * JQuery Pick (used to display related products)
 */
(function( $ ){
  $.fn.pick = function(count) {

    var howMany = count || 4;

    // Picking random numbers without repeating.
    var index_array = [];
    var original_obj_size = this.size();
    for (var i=0; i<original_obj_size; i++) {
      index_array.push(i);
    }
    //+ Jonas Raoni Soares Silva
    //@ http://jsfromhell.com/array/shuffle [rev. #1]
    var shuffle = function(v) {
      for (var j, x, i = v.length; i; j = parseInt(Math.random() * i), x = v[--i], v[i] = v[j], v[j] = x);
      return v;
    };
    var new_index_array = shuffle(index_array).slice(0,howMany);

    // Ditching unpicked elements and removing those from the returned set.
    return this.each(function(i) {
      if ($.inArray(i,new_index_array) === -1) {
        $(this).remove();
      }
    }).filter(function() {
      if (this.parentNode === null) {
        return false;
      }
      else {
        return true;
      }
    });

  };
})( jQuery );
/**
 * Callback that automatically updates the variant
 */

window.maestroooProduct = function(options) {
  var variant = options['variant'],
      context = $('[data-product-id="' + options['productId'] + '"]'),
      offers = context.find('.product-offer'),
      inventory = context.find('.variant-inventory-quantity'),
      optionsContainer = context.find('.product-options'),
      labelsContainer = offers.find('.product-labels'),
      pricesContainer = offers.find('.product-prices'),
      notifyForm = context.find('.notify-soldout-form'),
      labelsNewContainer = context.find('.product-variant-status');

  
  // We remove all the things that may change
  inventory.hide();
  pricesContainer.find('.price, .sale-percent').remove().end();
  labelsContainer.find('.product-label').show();
  labelsContainer.find('.sold-out-label, .unavailable-label').hide();
  optionsContainer.find('.button-add-to-cart-container').show();
  optionsContainer.find('.button-add-to-cart-container .button-add-to-cart').show();
  optionsContainer.find('.back-in-stock').hide();
  labelsNewContainer.find('.product-variant-status-label--sold-out').hide();
  labelsNewContainer.find('.product-variant-status-label--last').hide();
   optionsContainer.find('.notify__trigger').hide();
  
  // There are a lot of things we need to change... so let's start!
  if (variant) {

    // This one allows to check the right color if swatch are used
    for (var i = 0 ; i < variant.options.length ; i++) {
      var radioButtonValue = variant.options[i].replace(/([ !"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~])/g,'\\\\$1');
      var radioButton = context.find('.swatch[data-option-index="' + i + '"]').find(':radio[value="' + radioButtonValue + '"]');

      if (radioButton.size()) {
        radioButton.closest('.swatch-element').addClass('active');
        radioButton.get(0).checked = true;
      }
    }

    if (!variant['available']) {
      // If variant only is not available... we show the sold out label, and hide the "Add to Cart" button
      labelsContainer.find('.sold-out-label').css('display', 'inline-block');
      
      optionsContainer.find('.button-add-to-cart-container .button-add-to-cart').hide();

      optionsContainer.find('.notify__trigger').show();
      //optionsContainer.find('.back-in-stock').show();
      labelsNewContainer.find('.product-variant-status-label--sold-out').show();      
      notifyForm.show();

    } else {
      notifyForm.hide();
      context.find('.product-variants').show();
      
      var price = Shopify.formatMoney(variant['price'], options.moneyFormat),
          compareAtPrice = Shopify.formatMoney(variant['compare_at_price'], options['moneyFormat']);

      if (variant['compare_at_price'] > variant['price']) {
        var percentDrop = (variant['compare_at_price'] - variant['price']) / variant['compare_at_price'] * 100;

        pricesContainer.prepend('<span class="new-price price money">' + price + '</span>')
          .prepend('<span class="old-price price money">' + compareAtPrice + '</span>');

        if (percentDrop > 0) {
          
          pricesContainer.append('<span class="sale-percent">' + Math.round(percentDrop) + '%</span>');
          
        }
      } else {
        pricesContainer.prepend('<span class="price money">' + price + '</span>');
      }
    }

    // We need to update the quantity
    if (inventory.length > 0 && variant['inventory_management'] !== null) {
      inventory.find('.count').text(variant['inventory_quantity']).end().show();
    }
    
    if(variant.inventory_quantity == 1) {
      labelsNewContainer.find('.product-variant-status-label--last').show();
    }
    
    // Update variant image, if one is set
    var $productImage = $('#ProductPhotoImg'),
        $productImageFeature = $('#ProductPhoto')

    
    // If the variant has a featured image associated with it, we need to modify the featured image
    if (variant['featured_image']) {
      $('.product-showcase .featured-image-list li').removeClass('active')
        .filter('[data-image-id=' + variant['featured_image']['id'] + ']')
        .addClass('active');
      
      var newImg = variant['featured_image'],
          el = $productImage[0];

      var $newImage = $('.product-single__photo[data-image-id="' + newImg.id + '"]');
      var imageIndex = $newImage.parents('li').not('.slick-cloned').data('slick-index');
      $productImageFeature.slick('slickGoTo', imageIndex);
    }
    
    
    
    
  } else {
    // This is an unavailable variant, so we need to hide the "add to cart" button, and show the "unavailable" label
    optionsContainer.find('.button-add-to-cart-container').hide();
    labelsContainer.find('.product-label').hide().end().find('.unavailable-label').css('display', 'inline-block');
    
  }

  Currency.convertAll(options['shopCurrency'], $('[name=currencies]').val());
  
};
var router = new RouterRouter();

/**
 * ----------------------------------------------------------------------------------------------------
 * ACCOUNT ADDRESSES ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

router.route('account/addresses', function() {
  /**
   * -------------------------
   * INIT ADDRESS SELECTOR
   * -------------------------
   */

  new Shopify.CountryProvinceSelector('address_country_new', 'address_province_new', {hideElement: 'address-province-container-new'});
});
/**
 * ----------------------------------------------------------------------------------------------------
 * ACCOUNT LOGIN ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

router.route('account/login', function() {
  var switchToReset = function() {
    $('.login-form, .recover-password-form').toggle();
    $('.page-title').html("Recover your Password");
  };

  // When we submit a reset password, Shopify redirects to the login page, but with the "#recover" hash
  if (window.location.hash === '#recover') {
    switchToReset();
  }

  $('.forgot-password-link').on('click', function() {
    switchToReset();
  });
});
/**
 * ----------------------------------------------------------------------------------------------------
 * CODE EXECUTED FOR EACH ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

router.route('*all', function() {
  // Is used to eliminate 300ms delay on iOS
  FastClick.attach(document.body);

  if ($('html').hasClass('ie8')) {
    $('.fancybox.search-toggle').fancybox({
      minWidth: 400,
      topRatio: 0.3,
      wrapCSS: 'mega-search',
      afterShow: function () {
        $('#search-autocomplete').focus();
      }
    });
  } else {
    $('.fancybox.search-toggle').fancybox({
      minWidth: 400,
      topRatio: 0.3,
      wrapCSS: 'mega-search',
      afterShow: function() {
        $('#search-autocomplete').focus();
      },
      helpers : {
        overlay : {
          css : {
            'background' : 'rgba(255, 255, 255, 0.92)'
          }
        }
      }
    });
  }


  /**
   * -------------------------
   * MENU ON MOBILE
   * -------------------------
   */

  $('.header-mobile-nav .search-link').on('click', function() {
    $(this).next('.tab-content').find('input').focus();
  });

  $('.header-mobile-nav .mobile-nav-tabs > li a').on('click', function() {
    $(this).parent().siblings().removeClass('active').end().toggleClass('active');
  });

  $('.header-mobile-nav .see-more').on('click', function() {
    var elem = $(this),
        text = elem.html();

    elem.html(text === '<i class="icon-plus"></i>' ? '<i class="icon-minus"></i>' : '<i class="icon-plus"></i>');

    elem.closest('.dropdown').toggleClass('open');

    return false;
  });

  if (Modernizr.touch) {
    $('.header-desktop-nav .header-nav-links .is-nested > a, .header-desktop-nav .header-nav-links .is-sub-nested > a').on('click', function(event) {
      event.preventDefault();
    });
  }

  /**
   * -------------------------
   * AUTO-COMPLETION
   * -------------------------
   */
  
    $('#search-autocomplete').awesomecomplete({
      resultLimit: 50,
      typingDelay: 50,
      suggestionListClass: 'awesomecomplete',
      splitTerm: false,

      dataMethod: function(term, event, done) {
        $.ajax({
          url: '/search',
          dataType: 'json',
          data: {
            type: 'product',
            q: term + '*', // We automatically add wildcard for partial matching
            view: 'json'
          }
        }).then(function(data) {
          done(data);
        });
      },

      sortFunction: function() {
        return 0;
      },

      renderFunction: function(result, term) {
        if (result['results_count'] !== undefined) {
          return '<a class="ac-results-count" href="' + result['url'] + '">' + "See all results"
            + ' (' + result['results_count'] + ')' + '</a>';
        }

        return '<a href="' + result['url'] + '"><img class="ac-product-image" src="' + result['thumbnail'] + '">'
          + '<div class="ac-product-info"><span class="ac-product-title">' + result['title'] + '</span>'
          + '<span class="ac-price-min">' + "" + ' ' + result['price_min'] + '</span></div></a>';
      },

      onComplete: function(dataItem) {
        location.href = dataItem['url'];
      }
    });
  

  /**
   * -------------------------
   * AUTOMATIC CURRENCY CONVERSION
   * -------------------------
   */

  

  /**
   * -------------------------
   * QUICK SHOP
   * -------------------------
   */

  

  /**
   * -------------------------
   * BACK TO TOP BUTTON
   * -------------------------
   */

  
    var backToTopOffset = 300,
        backToTopDuration = 500;

    $(window).on('scroll', function() {
      if ($(this).scrollTop() > backToTopOffset) {
        $('#back-to-top').fadeIn(backToTopDuration);
      }
      else {
        $('#back-to-top').fadeOut(backToTopDuration);
      }
    });

    $('#back-to-top').off('click.smoothscroll').on('click', function(e) {
      e.preventDefault();
      $('html, body').animate( { scrollTop: 0 }, backToTopDuration);

      return false;
    });
  

  /**
   * -------------------------
   * MARKETING POPUP
   * -------------------------
   */

  
});
/**
 * ----------------------------------------------------------------------------------------------------
 * COLLECTION ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

router.route('cart', function() {
  var cart = $('#cart');

  /**
   * -------------------------
   * AJAXIFY THE CART
   * -------------------------
   */

  cart.cartAjaxify();

  /**
   * -------------------------
   * TERMS AND CONDITIONS CHECKBOX
   * -------------------------
   */

  
    cart.find('form').submit(function(event) {
      var checkbox = $(event.currentTarget).find('#terms-checkbox');

      if (!checkbox.is(':checked')) {
        alert("You must agree with the Terms and Conditions of sales to check out.");
        return false;
      }
    });
  

  /**
   * -------------------------
   * SHIPPING ESTIMATOR
   * -------------------------
   */

  
});
/**
 * ----------------------------------------------------------------------------------------------------
 * COLLECTION ROUTE
 * ----------------------------------------------------------------------------------------------------
 */
let collection_url = routes.collection_url.replace('/', '');
console.log(`${collection_url}`)

router.route(`${collection_url}/*type`, function() {
  /**
   * -------------------------
   * SORT BY
   * -------------------------
   */

    Shopify.queryParams = {};

    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');

        if (aKeyValue.length > 1) {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }

    $('#sort-by').val(Shopify.queryParams['sort_by'] || window.shop.collectionDefaultSortBy || 'manual')
      .on('change', function() {
        Shopify.queryParams.sort_by = $(this).val();
        location.search = decodeURIComponent($.param(Shopify.queryParams));
      });
    console.log('2')
    $('.styled-select.filters select').on('change', function(event) {
      console.log(event.currentTarget)
      window.location.href = $(event.currentTarget).find(':selected').val();
    });

  /**
   * -------------------------
   * PAGINATION MODE
   * -------------------------
   */

  
});
/**
 * ----------------------------------------------------------------------------------------------------
 * INDEX ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

router.route('', function() {
  /**
   * -------------------------
   * SLIDER
   * -------------------------
   */

  
    $(window).load(function() {
      $('.flexslider').flexslider({
        animation: "fade",
        useCSS: true,
        smoothHeight: true,
        prevText: '',
        nextText: '',
        controlsContainer: '.flex-controls',
        controlNav: false,
        slideshow: true,
        slideshowSpeed: "4000",
        randomize: false
      });
    });
  

  /**
   * -------------------------
   * INSTAGRAM
   * -------------------------
   */

  
});
/**
 * ----------------------------------------------------------------------------------------------------
 * INDEX ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

router.route('pages/instagram-feed', function() {
  /**
   * -------------------------
   * INSTAGRAM
   * -------------------------
   */

  
});
/**
 * ----------------------------------------------------------------------------------------------------
 * PRODUCT QUICK SHOP ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

var productQuickShopRoute = function() {
  // We do this only on Quick Shop to avoid the fancybox to open for the quick shop, otherwise it would be
  // a popup inside the popup ^^.
  $('.image-featured').on('click', function() {
    return false;
  });
};
/**
 * ----------------------------------------------------------------------------------------------------
 * PRODUCT ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

var productRoute = function() {
  /**
   * -------------------------
   * ACTIVATE THINGS LIKE ZOOM AND UPDATE THE FEATURED IMAGE
   * -------------------------
   */
  $('.featured-image-list').featurify();
  /**
   * -------------------------
   * BACK IN STOCK
   * -------------------------
   */

  
    $('.back-in-stock-form').submit(function(event) {
      event.preventDefault();

      var email = $(event.target).find('input').val(),
          variantId = $('[name=id]').val();

      BISPopover.create(email, variantId).then(function(data) {
        var msg = '';

        $('.back-in-stock .alert-box').hide();

        if (data.status == 'OK') {
          msg = data.message; // just show the success message
          $('.back-in-stock .alert-success').show().find('.message').text(msg);
          $('.back-in-stock-form').hide();
        } else { // it was an error
          for (var k in data.errors) {  // collect all the error messages into a string
            msg += data.errors[k].join();
          }

          $('.back-in-stock .alert-error').show().find('.message').text(msg);
        }
      });
    });
  

  /**
   * -------------------------
   * COLOR SWATCH
   * -------------------------
   */

  

  /**
   * -------------------------
   * AJAX ADD TO CART
   * -------------------------
   */

  
    $('.button-add-to-cart').productAjaxify();
  

  /**
   * -------------------------
   * RELATED PRODUCTS
   * -------------------------
  */

  

    /**
   * -------------------------
   * FANCYBOX (LIGHTBOX)
   * -------------------------
   */

  $('.image-showcase.fancybox').fancybox({
    openEffect  : 'fade',
    closeEffect : 'fade',
    nextEffect  : 'fade',
    prevEffect  : 'fade',
    wrapCSS     : 'image-showcase-fancybox',
    topRatio    : 0.2,
    padding     : 0,
    margin      : [20, 60, 150, 60],
    helpers : {
      overlay : {
        css : {
          'background' : 'rgba(0, 0, 0, 0.9)'
        }
      },
      title: null
    },
    afterLoad: function() {
      var list = $('#product-showcase-links');

      if (!list.length) {
        list = $('<ul id="product-showcase-links">');

        for (var i = 0; i < this.group.length; i++) {
          var thumbnail = this.group[i].element.attr('data-thumbnail'),
              html = '<li data-index="' + i + '"><div class="overlay"></div><img src="' + thumbnail + '"></li>';

          $(html).click(function() {
            $.fancybox.jumpto($(this).data('index'));
          }).appendTo(list);
        }

        list.appendTo('body');
      }

      list.find('li').removeClass('active').eq(this.index).addClass('active');
    },
    beforeClose: function() {
      $('#product-showcase-links').remove();
    }
  });
};

router.route('products/*type', productRoute);
router.route('collections/*collection/products/*type', productRoute);
/**
 * ----------------------------------------------------------------------------------------------------
 * SEARCH ROUTE
 * ----------------------------------------------------------------------------------------------------
 */

router.route('search', function() {
  /**
   * -------------------------
   * PAGINATION MODE
   * -------------------------
   */

  
});